// extracted by mini-css-extract-plugin
export default {"wrapperLogo":"Header_wrapperLogo__B+YpQ","logotype":"Header_logotype__rRkdS"};